export default {
  company: "ក្រុមហ៊ុន",
  share_holder: "អ្នកកាន់ភាគហ៊ុន",
  super_senior: "ភ្នាក់ងារ​ជាន់ខ្ពស់​បំផុត",
  senior: "ភ្នាក់ងារ​ជាន់ខ្ពស់",
  master: "ម្ចាស់គណនី",
  agent: "ភ្នាក់ងារ",
  member: "សមាជិក",

  account_id: "ឈ្មោះអ្នកប្រើប្រាស់",
  action: "សកម្មភាព",
  available_credit: "ឥណទានដែលអាចប្រើបាន",
  active: "សកម្ម",
  account_balance: "សមតុល្យគណនី",
  agent_credit: "ឥណទានភ្នាក់ងារ",
  authority: "សិទ្ធិ",
  account_information: "ព័ត៌មានគណនី",
  account_list: "បញ្ជីគណនី",
  audit_by: "សវនកម្មដោយ",
  add_account: "បន្ថែមគណនី",
  add_sub_account: "បន្ថែមគណនីរង",
  authority_option: "ជម្រើសសិទ្ធិ",
  account: "គណនី",
  access_log: "កំណត់ត្រាចូលប្រើ",
  account_log: "កំណត់ត្រាគណនី",
  account_details: "ព័ត៌មានលម្អិតអំពីគណនី",
  action_by: "អនុវត្តដោយ",
  away_team_name: "ឈ្មោះក្រុមភ្ញៀវ",
  amount: "ចំនួនទឹកប្រាក់",
  account_before_balance: "សមតុល្យមុន",
  account_after_balance: "សមតុល្យក្រោយ",
  active_bet_list: "បញ្ជីភ្នាល់សកម្ម",
  agent_win_all: "ភ្នាក់ងារឈ្នះទាំងស្រុង",
  agent_win_half: "ភ្នាក់ងារឈ្នះពាក់កណ្ដាល",
  agent_lose_all: "ភ្នាក់ងារបាត់ទាំងស្រុង",
  agent_lose_half: "ភ្នាក់ងារបាត់ពាក់កណ្ដាល",
  accumulate_win: "ការឈ្នះសរុប",
  add_sub: "បន្ថែមគណនីរង",
  account_type: "ប្រភេទគណនី",
  account_pt: "អត្រាចំណែកគណនី",
  account_min: "អត្រាចំណែកអប្បបរមា",
  away_score: "ពិន្ទុក្រុមភ្ញៀវ",
  add_secondary_full: "បន្ថែមគណនីបន្ទាប់",
  accumulate_balance: "សមតុល្យសរុប",
  away: "ក្រុមភ្ញៀវ",
  aa: "ខាងក្រោម: ភ្ញៀវ | ពេញម៉ោង: ភ្ញៀវ",
  ad: "ខាងក្រោម: ភ្ញៀវ | ពេញម៉ោង: ស្មើ",
  ah: "ខាងក្រោម: ភ្ញៀវ | ពេញម៉ោង: ផ្ទះ",
  anb: "ភ្ញៀវ គ្មានការភ្នាល់",
  all: "ទាំងអស់",
  account_existed: "គណនីមានរួចហើយ។",
  account_not_existed: "គណនីមិនមានទេ។",
  account_status: "ស្ថានភាពគណនី",
  account_block: "បិទគណនី",
  account_unblock: "បើកគណនីឡើងវិញ",
  add_secondary: "បន្ថែមគណនីបន្ទាប់",
  secondary_id_acknowledge_title: "ការទទួលស្គាល់អត្តសញ្ញាណរង",
  secondary_id_label: "អត្តសញ្ញាណរង",
  agent_bulk: "ដំណើរការភ្នាក់ងារច្រើន",
  abandoned: "លុបបោះបង់",
  account_list_alert: "ការជូនដំណឹងសមាជិក",
  adjustment: "ការកែសម្រួល",

  balance: "សមតុល្យ",
  bet: "ការភ្នាល់",
  block: "ទប់ស្កាត់",
  blocked: "ត្រូវបានទប់ស្កាត់",
  back: "ត្រឡប់ក្រោយ",
  bet_limit: "កំណត់ការភ្នាល់",
  basketball: "បាល់បោះ",
  baseball: "បេសបាល់",
  bet_limit_log: "កំណត់ត្រាការភ្នាល់",
  browser_agent: "កម្មវិធីរុករក",
  bet_limit_packages: "កញ្ចប់កំណត់ការភ្នាល់",
  ball: "បាល់",
  bet_count: "ចំនួនការភ្នាល់",
  bet_type: "ប្រភេទភ្នាល់",
  bl: "កំណត់ការភ្នាល់",
  basketball_min_bet: "@:ui.basketball @:ui.min_bet",
  basketball_max_bet: "@:ui.basketball @:ui.max_bet",
  basketball_max_per_match: "@:ui.basketball @:ui.max_per_match",
  baseball_min_bet: "@:ui.baseball @:ui.min_bet",
  baseball_max_bet: "@:ui.baseball @:ui.max_bet",
  baseball_max_per_match: "@:ui.baseball @:ui.max_per_match",
  bet_list: "បញ្ជីការភ្នាល់",
  bet_list_4d: "បញ្ជីភ្នាល់ 4D",
  bet_list_esports2: "បញ្ជីភ្នាល់ ESports2",
  bs: "ទាំងពីរជាអ្នកទាំងអស់",

  credit: "ឥណទាន",
  cm: "កម្រៃជើងសារ",
  close: "បិទ",
  cancel: "បោះបង់",
  continue: "បន្ត",
  created_on: "បង្កើតនៅថ្ងៃ",
  created_by_on: "បង្កើតដោយ/នៅ",
  updated_by_on: "ធ្វើបច្ចុប្បន្នភាពដោយ/នៅ",
  copy_and_create: "ចម្លង និង បង្កើត",
  copy: "ចម្លង",
  confirm_password: "បញ្ជាក់ពាក្យសម្ងាត់",
  confirm_security_code: "បញ្ជាក់លេខសុវត្ថិភាព",
  contact_phone: "លេខទូរស័ព្ទ",
  contact_email: "អ៊ីមែល",
  cash_balance: "សមតុល្យសាច់ប្រាក់",
  currency: "រូបិយប័ណ្ណ",
  credit_limit: "ដែនកំណត់ឥណទាន",
  credit_balance: "សមតុល្យឥណទាន",
  commission: "កម្រៃជើងសារ",
  correct_score: "ពិន្ទុត្រឹមត្រូវ",
  correct_score_bl: "ពិន្ទុត្រឹមត្រូវ (@:ui.soccer)",
  commission_log: "កំណត់ត្រកម្រៃជើងសារ",
  current_balance: "សមតុល្យបច្ចុប្បន្ន",
  cancelled_bet_list: "បញ្ជីភ្នាល់ដែលបានលុបចោល",
  category: "ប្រភេទ",
  copy_to_bottom: "ចម្លងទៅខាងក្រោម",
  comm_sportsbook_hdp_a: "HDP A",
  comm_sportsbook_hdp_b: "HDP B",
  comm_sportsbook_hdp_c: "HDP C",
  comm_sportsbook_hdp_d: "HDP D",
  comm_sportsbook_hdp_e: "HDP E",
  comm_sportsbook_hdp_f: "HDP F",
  comm_sportsbook_hdp_g: "HDP G",
  comm_sportsbook_hdp_h: "HDP H",
  comm_sportsbook_hdp_i: "HDP I",
  comm_sportsbook_hdp_j: "HDP J",
  comm_sportsbook_1x2: "1X2",
  comm_sportsbook_others: "ផ្សេងៗ",
  comm_sportsbook_hdp_packages: "កញ្ចប់ HDP",
  comm_slots: "ស្លុត",
  comm_casino: "កាស៊ីណូផ្សាយបន្តផ្ទាល់",
  comm_lotto: "ឡូតូ",
  comm_keno: "គីណូ",
  comm_cockfight: "ESports2",
  comm_lottery_1d: "ឆ្នោត 1D",
  comm_lottery_2d: "ឆ្នោត 2D",
  comm_lottery_3d: "ឆ្នោត 3D",
  comm_lottery_4d: "ឆ្នោត 4D",
  comm_tournament: "ការប្រកួត",
  completed: "បានបញ្ចប់",
  clean_sheet: "រក្សាគ្រាប់បាល់ស្អាត",
  cockfight: "ESports2",
  esports2: "ESports2",
  cockfight_bet_limit_packages: "កញ្ចប់កំណត់ការភ្នាល់ ESports2",
  combination: "បន្សំ",
  cs_min_bet: "@:ui.correct_score @:ui.min_bet",
  cs_max_bet: "@:ui.correct_score @:ui.max_bet",
  cs_max_per_match: "@:ui.correct_score @:ui.max_per_match",

  combine: {
    bet_limit_A: "លីមីត A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_B: "លីមីត B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_C: "លីមីត C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_D: "លីមីត D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_E: "លីមីត E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_F: "លីមីត F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_G: "លីមីត G (@:ui.min = 500 @:ui.max = 30000)",

    // bet_limit_AUDA: "លីមីត A (@:ui.min = 1 @:ui.max = 100)",
    // bet_limit_AUDB: "លីមីត B (@:ui.min = 1 @:ui.max = 125)",
    // bet_limit_AUDC: "លីមីត C (@:ui.min = 1 @:ui.max = 400)",
    // bet_limit_AUDD: "លីមីត D (@:ui.min = 5 @:ui.max = 1,500)",
    // bet_limit_AUDE: "លីមីត E (@:ui.min = 5 @:ui.max = 2,500)",
    // bet_limit_AUDF: "លីមីត F (@:ui.min = 5 @:ui.max = 5,000)",
    // bet_limit_AUDG: "លីមីត G (@:ui.min = 5 @:ui.max = 10,000)",

    bet_limit_KRWA: "លីមីត A (@:ui.min = 1,500 @:ui.max = 200,000)",
    bet_limit_KRWB: "លីមីត B (@:ui.min = 2,000 @:ui.max = 200,000)",
    bet_limit_KRWC: "លីមីត C (@:ui.min = 2,000 @:ui.max = 400,000)",
    bet_limit_KRWD: "លីមីត D (@:ui.min = 4,000 @:ui.max = 800,000)",
    bet_limit_KRWE: "លីមីត E (@:ui.min = 4,000 @:ui.max = 2,000,000)",
    bet_limit_KRWF: "លីមីត F (@:ui.min = 4,000 @:ui.max = 4,000,000)",
    bet_limit_KRWG: "លីមីត G (@:ui.min = 4,000 @:ui.max = 6,000,000)",

    bet_limit_CNYA: "លីមីត A (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CNYB: "លីមីត B (@:ui.min = 10 @:ui.max = 1000)",
    bet_limit_CNYC: "លីមីត C (@:ui.min = 10 @:ui.max = 2000)",
    bet_limit_CNYD: "លីមីត D (@:ui.min = 20 @:ui.max = 5000)",
    bet_limit_CNYE: "លីមីត E (@:ui.min = 20 @:ui.max = 10000)",
    bet_limit_CNYF: "លីមីត F (@:ui.min = 400 @:ui.max = 20000)",
    bet_limit_CNYG: "លីមីត G (@:ui.min = 20 @:ui.max = 50000)",

    bet_limit_HKDA: "លីមីត A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_HKDB: "លីមីត B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_HKDC: "លីមីត C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_HKDD: "លីមីត D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_HKDE: "លីមីត E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_HKDF: "លីមីត F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_HKDG: "លីមីត G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_SGDA: "លីមីត A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_SGDB: "លីមីត B (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_SGDC: "លីមីត C (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_SGDD: "លីមីត D (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_SGDE: "លីមីត E (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_SGDF: "លីមីត F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_SGDG: "លីមីត G (@:ui.min = 5 @:ui.max = 10,000)",

    bet_limit_VNDA: "លីមីត A (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_VNDB: "លីមីត B (@:ui.min = 10 @:ui.max = 3,000)",
    bet_limit_VNDC: "លីមីត C (@:ui.min = 40 @:ui.max = 5,000)",
    bet_limit_VNDD: "លីមីត D (@:ui.min = 80 @:ui.max = 25,000)",
    bet_limit_VNDE: "លីមីត E (@:ui.min = 80 @:ui.max = 50,000)",
    bet_limit_VNDF: "លីមីត F (@:ui.min = 80 @:ui.max = 100,000)",
    bet_limit_VNDG: "លីមីត G (@:ui.min = 80 @:ui.max = 150,000)",
	
	bet_limit_MYRA: "លីមីត A (@:ui.min = 1 @:ui.max = 500)",
    bet_limit_MYRB: "លីមីត B (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_MYRC: "លីមីត C (@:ui.min = 10 @:ui.max = 1,000)",
    bet_limit_MYRD: "លីមីត D (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_MYRE: "លីមីត E (@:ui.min = 100 @:ui.max = 5,000)",
    bet_limit_MYRF: "លីមីត F (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MYRG: "លីមីត G (@:ui.min = 500 @:ui.max = 20,000)",
	
	bet_limit_USDA: "លីមីត A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_USDB: "លីមីត B (@:ui.min = 1 @:ui.max = 125)",
    bet_limit_USDC: "លីមីត C (@:ui.min = 1 @:ui.max = 400)",
    bet_limit_USDD: "លីមីត D (@:ui.min = 5 @:ui.max = 1,500)",
    bet_limit_USDE: "លីមីត E (@:ui.min = 5 @:ui.max = 2,500)",
    bet_limit_USDF: "លីមីត F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_USDG: "លីមីត G (@:ui.min = 5 @:ui.max = 10,000)",
	
	bet_limit_THBA: "លីមីត A (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_THBB: "លីមីត B (@:ui.min = 50 @:ui.max = 5,000)",
    bet_limit_THBC: "លីមីត C (@:ui.min = 100 @:ui.max = 10,000)",
    bet_limit_THBD: "លីមីត D (@:ui.min = 100 @:ui.max = 50,000)",
    bet_limit_THBE: "លីមីត E (@:ui.min = 100 @:ui.max = 100,000)",
    bet_limit_THBF: "លីមីត F (@:ui.min = 100 @:ui.max = 200,000)",
    bet_limit_THBG: "លីមីត G (@:ui.min = 100 @:ui.max = 300,000)",
	
	bet_limit_IDRA: "លីមីត A (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_IDRB: "លីមីត B (@:ui.min = 20 @:ui.max = 1,500)",
    bet_limit_IDRC: "លីមីត C (@:ui.min = 20 @:ui.max = 3,000)",
    bet_limit_IDRD: "លីមីត D (@:ui.min = 25 @:ui.max = 15,000)",
    bet_limit_IDRE: "លីមីត E (@:ui.min = 25 @:ui.max = 30,000)",
    bet_limit_IDRF: "លីមីត F (@:ui.min = 25 @:ui.max = 60,000)",
    bet_limit_IDRG: "លីមីត G (@:ui.min = 25 @:ui.max = 100,000)",

    bet_limit_MMKA: "លីមីត A (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_MMKB: "លីមីត B (@:ui.min = 2 @:ui.max = 200)",
    bet_limit_MMKC: "លីមីត C (@:ui.min = 2 @:ui.max = 500)",
    bet_limit_MMKD: "លីមីត D (@:ui.min = 2 @:ui.max = 1,000)",
    bet_limit_MMKE: "Limit E (@:ui.min = 4 @:ui.max = 2,000)",
    bet_limit_MMKF: "Limit F (@:ui.min = 4 @:ui.max = 5,000)",
    bet_limit_MMKG: "Limit G (@:ui.min = 4 @:ui.max = 10,000)",
    
    bet_limit_MMOA: "Limit A (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_MMOB: "Limit B (@:ui.min = 2 @:ui.max = 200)",
    bet_limit_MMOC: "Limit C (@:ui.min = 2 @:ui.max = 500)",
    bet_limit_MMOD: "Limit D (@:ui.min = 2 @:ui.max = 1,000)",
    bet_limit_MMOE: "Limit E (@:ui.min = 4 @:ui.max = 2,000)",
    bet_limit_MMOF: "Limit F (@:ui.min = 4 @:ui.max = 5,000)",
    bet_limit_MMOG: "Limit G (@:ui.min = 4 @:ui.max = 10,000)",

    bet_limit_ARSA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_ARSB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_ARSC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_ARSD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_ARSE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_ARSF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_ARSG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_AUDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_AUDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_AUDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_AUDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_AUDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_AUDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_AUDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BDTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BDTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BDTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BDTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BDTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BDTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BDTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BNDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BNDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BNDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BNDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BNDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BNDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BNDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BRLA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BRLB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BRLC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BRLD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BRLE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BRLF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BRLG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_EURA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_EURB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_EURC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_EURD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_EURE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_EURF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_EURG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_GOOA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_GOOB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_GOOC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_GOOD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_GOOE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_GOOF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_GOOG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_INRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_INRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_INRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_INRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_INRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_INRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_INRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_JPYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_JPYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_JPYC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_JPYD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_JPYE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_JPYF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_JPYG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NPRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NPRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NPRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NPRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NPRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NPRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NPRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PKRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PKRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PKRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PKRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PKRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PKRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PKRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_TNDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_TNDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_TNDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_TNDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_TNDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_TNDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_TNDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_USTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_USTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_USTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_USTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_USTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_USTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_USTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PHPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PHPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PHPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PHPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PHPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PHPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PHPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_LAKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_LAKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_LAKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_LAKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_LAKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_LAKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_LAKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_LKRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_LKRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_LKRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_LKRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_LKRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_LKRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_LKRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_KHRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_KHRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_KHRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_KHRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_KHRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_KHRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_KHRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_AEDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_AEDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_AEDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_AEDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_AEDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_AEDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_AEDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_CADA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CADB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CADC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_CADD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_CADE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_CADF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_CADG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_CHFA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CHFB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CHFC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_CHFD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_CHFE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_CHFF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_CHFG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_DKKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_DKKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_DKKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_DKKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_DKKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_DKKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_DKKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_GBPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_GBPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_GBPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_GBPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_GBPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_GBPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_GBPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_MXNA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_MXNB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_MXNC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_MXND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_MXNE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MXNF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_MXNG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NGNA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NGNB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NGNC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NGND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NGNE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NGNF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NGNG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NOKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NOKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NOKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NOKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NOKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NOKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NOKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NZDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NZDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NZDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NZDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NZDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NZDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NZDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_RUBA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_RUBB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_RUBC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_RUBD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_RUBE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_RUBF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_RUBG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_SEKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_SEKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_SEKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_SEKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_SEKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_SEKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_SEKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_TRYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_TRYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_TRYC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_TRYD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_TRYE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_TRYF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_TRYG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_ZARA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_ZARB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_ZARC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_ZARD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_ZARE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_ZARF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_ZARG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_COPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_COPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_COPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_COPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_COPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_COPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_COPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PENA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PENB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PENC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PEND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PENE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PENF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PENG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_MNTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_MNTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_MNTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_MNTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_MNTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MNTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_MNTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_KESA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_KESB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_KESC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_KESD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_KESE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_KESF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_KESG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_PGKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PGKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PGKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PGKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PGKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PGKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PGKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_SARA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_SARB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_SARC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_SARD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_SARE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_SARF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_SARG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_JSTA: "Limit A (@:ui.min = 1 @:ui.max = 500)",
    bet_limit_JSTB: "Limit B (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_JSTC: "Limit C (@:ui.min = 10 @:ui.max = 1,000)",
    bet_limit_JSTD: "Limit D (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_JSTE: "Limit E (@:ui.min = 100 @:ui.max = 5,000)",
    bet_limit_JSTF: "Limit F (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_JSTG: "Limit G (@:ui.min = 500 @:ui.max = 20,000)",

    bet_limit_lottery_MYRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AUDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_CNYA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_HKDA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_IDRA: "Package A (@:m.D_BIG:150 @:m.D_SMALL:150 SA:60 @:ui.min:3)",
    bet_limit_lottery_KRWA: "Package A (@:m.D_BIG:13000 @:m.D_SMALL:13000 SA:5000 @:ui.min:300)",
    bet_limit_lottery_SGDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_THBA: "Package A (@:m.D_BIG:500 @:m.D_SMALL:500 SA:200 @:ui.min:10)",
    bet_limit_lottery_USDA: "Package A (@:m.D_BIG:10 @:m.D_SMALL:10 SA:5 @:ui.min:1)",
    bet_limit_lottery_VNDA: "Package A (@:m.D_BIG:250 @:m.D_SMALL:250 SA:100 @:ui.min:5)",
    bet_limit_lottery_MMKA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_MMOA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",

    bet_limit_lottery_ARSA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BDTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BRLA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_EURA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GOOA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_INRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_JPYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NPRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_USTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PHPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LAKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KHRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AEDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CADA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CHFA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_DKKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GBPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MXNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NGNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NOKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NZDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_RUBA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_SEKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TRYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_ZARA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_COPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PENA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MNTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KESA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PGKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_SARA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_JSTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",

    comm_limit_A: "ក្រុម A",
    comm_limit_B: "ក្រុម B",
    comm_limit_C: "ក្រុម C",
    comm_limit_D: "ក្រុម D",
    comm_limit_E: "ក្រុម E",
    comm_limit_F: "ក្រុម F",
    comm_limit_G: "ក្រុម G",
    comm_limit_H: "ក្រុម H",
    comm_limit_I: "ក្រុម I",
    comm_limit_J: "ក្រុម J",

    comm_parlay_mmo_a: "Parlay MMO (2-3)",
    comm_parlay_mmo_b: "Parlay MMO (4-12)",

    reset_password: "@:ui.reset @:ui.password",
    edit_password: "@:ui.edit @:ui.password",
    edit_settings: "@:ui.edit @:ui.settings",
    edit_profile: "@:ui.edit @:ui.profile",
    edit_authority: "@:ui.edit @:ui.authority",
    update_commission: "@:ui.update @:ui.commission",
    update_bet_limit: "@:ui.update @:ui.bet_limit",
    update_position_taking: "@:ui.update @:ui.position_taking",
    update_profile: "@:ui.update @:ui.profile"
  },

  downline_id: "លេខសម្គាល់អាណើកក្រោម",
  disabled: "បានបិទ",
  downline: "អាណើកក្រោម",
  dashboard: "ផ្ទាំងគ្រប់គ្រង",
  downline_list: "បញ្ជីអាណើកក្រោម",
  double_chance: "ឱកាសទ្វេដង",
  downline_credit: "ឥណទានអាណើកក្រោម",
  date: "កាលបរិច្ឆេទ",
  data: "ទិន្នន័យ",
  date_time: "កាលបរិច្ឆេទ/ម៉ោង",
  date_range: "ជួរថ្ងៃ",
  details: "ព័ត៌មានលម្អិត",
  draw: "ស្មើ",
  daily_statement: "របាយការណ៍ប្រចាំថ្ងៃ",
  daily_statement_member: "របាយការណ៍សមាជិក",
  daily_winlose: "ឈ្នះចាញ់ប្រចាំថ្ងៃ",
  daily_winlose_simple: "ឈ្នះចាញ់សាមញ្ញ",
  daily_winlose_details: "ឈ្នះចាញ់",
  daily_reset: "កំណត់ឡើងវិញប្រចាំថ្ងៃ",
  daily_winlose_platform: "ឈ្នះចាញ់តាមផលិតផល",
  daily_winlose_match: "ឈ្នះចាញ់តាមការប្រកួត",
  detail: "លម្អិត",
  downline_outstanding: "បំណុលអាណើកក្រោម",
  dd: "HT: ស្មើ | FT: ស្មើ",
  dh: "HT: ស្មើ | FT: ផ្ទះ",
  da: "HT: ស្មើ | FT: ទេសចរ",
  dnb: "ស្មើគ្មានភ្នាល់",
  draw_cancel: "ស្មើ",
  default: "លំនាំដើម",
  deposit: "ដាក់ប្រាក់",

  edit: "កែប្រែ",
  enter_information: "បញ្ចូលព័ត៌មាន",
  enable: "បើកដំណើរការ",
  esports: "កីឡាអេឡិចត្រូនិច",
  edit_account: "កែប្រែគណនី",
  edit_limit: "កែប្រែដែនកំណត់",
  early: "ដើម",
  event: "ព្រឹត្តិការណ៍",
  enabled: "បានបើក",
  esports_min_bet: "@:ui.esports @:ui.min_bet",
  esports_max_bet: "@:ui.esports @:ui.max_bet",
  esports_max_per_match: "@:ui.esports @:ui.max_per_match",
  even: "ស្មើ",
  edited: "បានកែប្រែ",
  export_excel: "នាំចេញ Excel",

  from: "ពី",
  full: "ពេញលេញ",

  forecast: "ព្យាករណ៍",
  forecast_soccer: "ព្យាករណ៍ (បាល់ទាត់)",
  freeze: "បិទ",
  full_name: "ឈ្មោះ",
  full_mode: "របៀបពេញលេញ",
  first_hdp: "HDP ដំបូង",
  first_ou: "OU ដំបូង",
  fh: "FH",
  forecast_details: "ព័ត៌មានលម្អិតអំពីព្យាករណ៍",
  full_time: "ពេលចប់ការប្រកួត",
  fglg: "@:m.BT_FG/@:m.BT_LG",
  first_goal: "គ្រាប់បាល់ដំបូង",
  first_half: "វគ្គទី១",
  fold: "ទុកចោល",

  grand_total: "សរុបរួម",
  gross_commission: "កម្រៃជើងសារ Bruto",
  game_name: "ឈ្មោះហ្គេម",
  game_provider: "ក្រុមហ៊ុនផ្ដល់ហ្គេម",
  game_result: "លទ្ធផលហ្គេម",
  game_result_details: "ព័ត៌មានលម្អិតលទ្ធផលហ្គេម",
  gross_winlose: "ចំណេញ/ខាតសរុប",
  game_type: "ប្រភេទហ្គេម",
  game_rules: "ច្បាប់ហ្គេមស្លុត",
  game_rules_title1: "",
  game_rules_content1: "",

  ht: "HT",
  half: "ពាក់កណ្ដាល",
  half_time: "ពេលពាក់កណ្ដាល",
  home: "ផ្ទះ",
  hdp: "HDP",
  hdp_packages: "កញ្ចប់ HDP",
  home_team_name: "ឈ្មោះក្រុមផ្ទះ",
  home_score: "ពិន្ទុផ្ទះ",
  hh: "HT: ផ្ទះ | FT: ផ្ទះ",
  hd: "HT: ផ្ទះ | FT: ស្មើ",
  ha: "HT: ផ្ទះ | FT: ទេសចរ",
  hdpou: "@:ui.hdp/@:ui.ou",
  htft: "@:ui.half_time/@:ui.full_time",
  hnb: "ផ្ទះគ្មានភ្នាល់",

  ip_address: "អាសយដ្ឋាន IP",
  id: "លេខសម្គាល់",

  jackpot: "ជេកផុត",

  key: "សោ",
  keno: "កេណូ",
  keno_bet_limit_packages: "កញ្ចប់ដែនកំណត់ភ្នាល់ Keno",

  log_id: "លេខសម្គាល់កំណត់ហេតុ",
  lottery: "លត្ឋ្រី",
  lottery_1d: "លត្ឋ្រី 1D",
  lottery_2d: "លត្ឋ្រី 2D",
  lottery_3d: "លត្ឋ្រី 3D",
  lottery_4d: "លត្ឋ្រី 4D",
  lotto: "លូតូ",
  log: "កំណត់ហេតុ",
  list: "បញ្ជី",
  logs: "កំណត់ហេតុ",
  login: "ចូល",
  logout: "ចាកចេញ",
  login_ip: "IP ការចូល",
  login_id: "លេខសម្គាល់ចូល",
  last_name: "នាមត្រកូល",
  live_casino: "កាស៊ីណូផ្សាយផ្ទាល់",
  livecasino: "កាស៊ីណូផ្សាយផ្ទាល់",
  lastweek: "សប្ដាហ៍មុន",
  lastmonth: "ខែមុន",
  last3month: "3 ខែមុន",
  league_id: "លេខសម្គាល់លីគ",
  league_name: "ឈ្មោះលីគ",
  league: "លីគ",
  livecasino_platform: "វេទិកាកាស៊ីណូផ្សាយផ្ទាល់",
  livecasino_upline_pt : "@:ui.live_casino @:ui.upline_pt",
  livecasino_account_pt : "@:ui.live_casino @:ui.account_pt",
  livecasino_upline_remaining : "@:ui.live_casino @:ui.upline_remaining",
  livecasino_account_min : "@:ui.live_casino @:ui.account_min",
  livecasino_bet_limit_packages: "កញ្ចប់ដែនកំណត់ភ្នាល់កាស៊ីណូផ្សាយផ្ទាល់",
  last_goal: "គ្រាប់ចុងក្រោយ",
  live: "ផ្សាយផ្ទាល់",
  lose: "ចាញ់",
  lose_half: "ចាញ់កន្លះ",
  last_week: "សប្ដាហ៍មុន",
  last_month: "ខែមុន",
  lotto_bet_limit_packages: "កញ្ចប់ដែនកំណត់ភ្នាល់លូតូ",
  lottery_bet_limit_packages: "កញ្ចប់ដែនកំណត់ភ្នាល់លត្ឋ្រី",

  member_log: "កំណត់ហេតុសមាជិក",
  member_balance: "សមតុល្យសមាជិក",
  master_credit: "ឥណទាន Master",
  member_credit_limit: "ដែនកំណត់ឥណទានសមាជិក",
  max_credit_limit: "ដែនកំណត់ឥណទានអតិបរមា",
  min_max_bet: "ភ្នាល់អប្បបរមា/អតិបរមា",
  min_bet: "ភ្នាល់អប្បបរមា",
  max_bet: "ភ្នាល់អតិបរមា",
  max_per_match: "អតិបរមាទំព័រប្រកួត",
  mix_parlay: "បញ្ចូលភ្នាល់សរុប",
  mmo_parlay: "Myanmar Parlay",
  money_line: "បន្ទាត់ប្រាក់",
  min: "អប្បបរមា",
  max: "អតិបរមា",
  market_type: "ប្រភេទទីផ្សារ",
  match_time: "ម៉ោងប្រកួត",
  match_id: "លេខសម្គាល់ប្រកួត",
  member_id: "ឈ្មោះអ្នកប្រើប្រាស់",
  match: "ការប្រកួត",
  master_outstanding: "ប្រាក់ជំពាក់របស់ Master",
  mode: "របៀប",
  member_outstanding: "ប្រាក់ជំពាក់របស់សមាជិក",
  member_outstanding_4d: "ប្រាក់ជំពាក់សមាជិក 4D",
  match_result: "លទ្ធផលការប្រកួត",
  messages: "សារ",
  message: "សារ",
  member_management: "ការគ្រប់គ្រងសមាជិក",
  member_bulk: "សមាជិកច្រើន",
  manila_nocomm: "Onlive & MT & Pretty Gaming & Evolution & Pragmatic & Sexy Gaming Livecasino គ្មានកម្រៃជើងសារ",
  m4d: "4D",
  marketing_tools: "ឧបករណ៍ទីផ្សារ",
  min_credit: "ឥណទានអប្បបរមា",

  new: "ថ្មី",
  new_login_id: "លេខសម្គាល់ចូលថ្មី",
  new_username: "ឈ្មោះអ្នកប្រើថ្មី",
  new_password: "ពាក្យសម្ងាត់ថ្មី",
  new_security_code: "កូដសុវត្ថិភាពថ្មី",
  new_account: "គណនីថ្មី",
  next: "បន្ទាប់",
  no_goal: "គ្មានគ្រាប់បាល់",
  "no/": "លេខរៀង",
  normal: "ធម្មតា",
  normal_announcements: "សេចក្តីជូនដំណឹងធម្មតា",

  on: "បើក",
  off: "បិទ",
  ok: "យល់ព្រម",
  over: "លើស",
  overview: "ទិដ្ឋភាពទូទៅ",
  old_password: "ពាក្យសម្ងាត់ចាស់",
  outstanding: "ជំពាក់",
  outstanding_balance: "សមតុល្យជំពាក់",
  over_under: "លើស/ក្រោម",
  odd_even: "គូ/សេស",
  ou: "ល/ក",
  oe: "គូ/សេស",
  others: "ផ្សេងៗ",
  odd: "សេស",
  oxt: "1X2",
  outright: "ជើងឯកសរុប",
  others_min_bet: "@:ui.others @:ui.min_bet",
  others_max_bet: "@:ui.others @:ui.max_bet",
  others_max_per_match: "@:ui.others @:ui.max_per_match",
  odds_display: "បង្ហាញអត្រាទាក់អារម្មណ៍",
  online_player: "អ្នកលេងអនឡាញ",
  opening_balance: "សមតុល្យដើម",
  oxtoeml: "@:ui.oe/@:m.BT_1X2/@:m.BT_ML",
  oxthdp: "Handicap 3 ផ្លូវ",
  others_sports: "កីឡាផ្សេងទៀត",

  pending: "កំពុងរង់ចាំ",
  platform: "វេទិកា",
  pt: "Position Taking",
  password: "ពាក្យសម្ងាត់",
  password_rules: "ការកំណត់ពាក្យសម្ងាត់",
  password_rules_intro: "ពាក្យសម្ងាត់ផ្តល់តែត្រូវតែបង្កើតតាមរយៈការកំណត់ខាងក្រោម:",
  security_code_rules: "ការកំណត់លេខកូដសុវត្ថិភាព",
  security_code_rules_intro: "លេខកូដសុវត្ថិភាពផ្តល់តែត្រូវតែបង្កើតតាមរយៈការកំណត់ខាងក្រោម:",
  profile_id: "លេខសម្គាល់ប្រវត្តិរូប",
  parent_id: "លេខសម្គាល់មេ",
  page_size: "ទំហំទំព័រ",
  profile: "ប្រវត្តិរូប",
  payment_option: "ជម្រើសទូទាត់",
  part_one: "ផ្នែកទីមួយ",
  part_two: "ផ្នែកទីពីរ",
  position_taking: "ការរើសទីតាំង",
  preview_settings: "ការកំណត់មើលជាមុន",
  preview: "មើលជាមុន",
  parlay: "Parlay",
  position_taking_log: "កំណត់ត្រារើសទីតាំង",
  platform_code: "លេខកូដវេទិកា",
  platform_name: "ឈ្មោះវេទិកា",
  pay: "បង់ប្រាក់ | បង់ទាំងអស់",
  payout: "ការបង់ប្រាក់ចេញ",
  product: "ផលិតផល",
  pending_matches: "ការប្រកួតកំពុងរង់ចាំ",
  pt_share: "ការចែករំលែកទីតាំង",
  platform_settings: "ការកំណត់វេទិកា",
  parlay_min_bet: "@:ui.parlay @:ui.min_bet",
  parlay_max_bet: "@:ui.parlay @:ui.max_bet",
  parlay_max_per_match: "@:ui.parlay @:ui.max_per_match",
  parlay_upline_pt : "@:ui.parlay @:ui.upline_pt",
  parlay_account_pt : "@:ui.parlay @:ui.account_pt",
  parlay_upline_remaining : "@:ui.parlay @:ui.upline_remaining",
  parlay_account_min : "@:ui.parlay @:ui.account_min",
  parlay_mmo_upline_pt : "Parlay MMO @:ui.upline_pt",
  parlay_mmo_account_pt : "Parlay MMO @:ui.account_pt",
  parlay_mmo_upline_remaining : "Parlay MMO @:ui.upline_remaining",
  parlay_mmo_account_min : "Parlay MMO @:ui.account_min",
  personal: "ផ្ទាល់ខ្លួន",
  personal_message: "សារផ្ទាល់ខ្លួន",
  password_reset: "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
  password_update: "អាប់ដេតពាក្យសម្ងាត់",

  refresh: "ធ្វើអាប់ដេត",
  reset: "កំណត់ឡើងវិញ",
  remaining_credit: "ឥណទាននៅសល់",
  remaining: "នៅសល់",
  rate: "អត្រា",
  report: "របាយការណ៍",
  running: "កំពុងដំណើរការ",
  remark: "ចំណាំ",
  refund: "សងប្រាក់វិញ",
  range: "ជួរ",
  reject: "បដិសេធ",
  reset_accumulate_win: "កំណត់ជ័យជំនះសរុបឡើងវិញ",
  refno: "លេខយោង",
  result: "លទ្ធផល",
  room_1: "សាធារណៈ",
  room_2: "ឯកជន",
  room_3: "សាធារណៈ (ឥតគិតថ្លៃ)",

  status: "ស្ថានភាព",
  succeed: "ជោគជ័យ",
  submit: "ដាក់ស្នើ",
  settings: "ការកំណត់",
  save: "រក្សាទុក",
  search: "ស្វែងរក",
  suspend: "ផ្អាក",
  security_tag: "ស្លាកសុវត្ថិភាព",
  sub_account: "គណនីរង",
  partner_list: "ដៃគូ",
  sports_type: "ប្រភេទកីឡា",
  ldiff: "LDiff",
  ldiff_tooltips: "Range from -0.5 to 0.5 (1 decimal place)",
  margin: "Margin",
  margin_tooltips: "Range from 5 to 20 (integer only)",
  ldiff_margin: "LDiff / Margin",
  ldiff_margin_priority: "Priority: Bet Type > Market Type > Sports Type",
  ldiff_margin_priority_tooltips: "The LDiff / Margin priority is Bet Type > Market Type > Sports Type. Please take note of this priority when making any changes.",
  partner_showing_for: "Showing for",
  partner_showing_for_hint: "Market Type and Bet Type below belong to this Sports Type.",
  partner_sport_card_hint: "Click to select. Double-click to edit.",
  search_and_copy: "ស្វែងរក និងចម្លង",
  search_existing: "ស្វែងរកអ្វីដែលមានរួច",
  skip: "រំលង",
  settings_limit: "កំណត់ការកំណត់",
  sportsbook: "កីឡា",
  slot_games: "ហ្គេមស្លុត",
  soccer: "បាល់ទាត់",
  sport_types: "ប្រភេទកីឡា",
  settlement: "ការបង្វិលលុយ",
  submatch_id: "លេខសម្គាល់ប្រកួតរង",
  score: "ពិន្ទុ",
  submatch_code: "លេខកូដប្រកួតរង",
  settlement_list: "បញ្ជីបង្វិលលុយ",
  sub_total: "សរុបរង",
  settle_amount: "ចំនួនបង្វិលលុយ",
  settlement_history: "ប្រវត្តិបង្វិលលុយ",
  sport_type: "ប្រភេទកីឡា",
  slot_platform: "វេទិកាស្លុត",
  simple_report: "របាយការណ៍សាមញ្ញ",
  status_update: "ធ្វើបច្ចុប្បន្នភាពស្ថានភាព",
  set_authority: "កំណត់សិទ្ធិ",
  soccer_hdp_upline_pt : "@:ui.soccer @:ui.hdp @:ui.upline_pt",
  soccer_hdp_account_pt : "@:ui.soccer @:ui.hdp @:ui.account_pt",
  soccer_hdp_upline_remaining : "@:ui.soccer @:ui.hdp @:ui.upline_remaining",
  soccer_hdp_account_min : "@:ui.soccer @:ui.hdp @:ui.account_min",
  soccer_1x2_upline_pt : "@:ui.soccer @:ui.oxt @:ui.upline_pt",
  soccer_1x2_account_pt : "@:ui.soccer @:ui.oxt @:ui.account_pt",
  soccer_1x2_upline_remaining : "@:ui.soccer @:ui.oxt @:ui.upline_remaining",
  soccer_1x2_account_min : "@:ui.soccer @:ui.oxt @:ui.account_min",
  soccer_others_upline_pt : "@:ui.soccer @:ui.others @:ui.upline_pt",
  soccer_others_account_pt : "@:ui.soccer @:ui.others @:ui.account_pt",
  soccer_others_upline_remaining : "@:ui.soccer @:ui.others @:ui.upline_remaining",
  soccer_others_account_min : "@:ui.soccer @:ui.others @:ui.account_min",
  hdp_mmo_upline_pt : "@:ui.hdp MMO @:ui.upline_pt",
  hdp_mmo_account_pt : "@:ui.hdp MMO @:ui.account_pt",
  hdp_mmo_upline_remaining : "@:ui.hdp MMO @:ui.upline_remaining",
  hdp_mmo_account_min : "@:ui.hdp MMO @:ui.account_min",
  slots_upline_pt : "@:ui.slots @:ui.upline_pt",
  slots_account_pt : "@:ui.slots @:ui.account_pt",
  slots_upline_remaining : "@:ui.slots @:ui.upline_remaining",
  slots_account_min : "@:ui.slots @:ui.account_min",
  soccer_min_bet: "@:ui.soccer @:ui.min_bet",
  soccer_max_bet: "@:ui.soccer @:ui.max_bet",
  soccer_max_per_match: "@:ui.soccer @:ui.max_per_match",
  slots: "ស្លុត",
  security_update: "ធ្វើបច្ចុប្បន្នភាពសុវត្ថិភាព",
  security_code: "លេខកូដសុវត្ថិភាព",
  success: "ជោគជ័យ",
  stock: "សារពើភណ្ឌ",
  special: "ពិសេស",
  special_announcements: "សេចក្តីប្រកាសពិសេស",
  seconds: "វិនាទី",
  security_disable: "បានបិទសុវត្ថិភាព",
  select_all: "ជ្រើសរើសទាំងអស់",
  system_parlay: "Parlay ប្រព័ន្ធ",
  settlement_agent_bulk: "បង្វិល Agent ជាក្រុម",
  settlement_agent: "ភ្នាក់ងារបង្វិល",
  settle_agent: "ភ្នាក់ងារបង្វិល",
  settlement_member_bulk: "បង្វិលសមាជិកជាក្រុម",
  settlement_member: "សមាជិកបង្វិល",
  settle_member: "សមាជិកបង្វិល",

  schedule_1: "ថ្ងៃច័ន្ទ | ច័ន្ទ",
  schedule_2: "ថ្ងៃអង្គារ | អង្គារ",
  schedule_3: "ថ្ងៃពុធ | ពុធ",
  schedule_4: "ថ្ងៃព្រហស្បតិ៍ | ព្រហ",
  schedule_5: "ថ្ងៃសុក្រ | សុក្រ",
  schedule_6: "ថ្ងៃសៅរ៍ | សៅរ៍",
  schedule_7: "ថ្ងៃអាទិត្យ | អាទិត្យ",

  twtn: "ឈ្នះដោយគ្មានបញ្ចូល",
  total_outstanding: "សរុបជំពាក់",
  target_id: "លេខសម្គាល់គោលដៅ",
  target_action: "សកម្មភាពគោលដៅ",
  total: "សរុប",
  types: "ប្រភេទ",
  total_goal: "គ្រាប់បាល់សរុប",
  tennis: "ទឹកនិស្ស",
  today: "ថ្ងៃនេះ",
  thisweek: "សប្ដាហ៍នេះ",
  thismonth: "ខែនេះ",
  transaction_log: "កំណត់ហេតុប្រតិបត្តិការ",
  account_action_log: "កំណត់ហេតុប្រតិបត្តិការគណនី",
  total_bet: "ចំនួនភ្នាល់សរុប",
  transaction_date: "ថ្ងៃ/ម៉ោងប្រតិបត្តិការ",
  transfer_method: "វិធីបញ្ជូន",
  turnover: "ការបង្វិលប្រាក់",
  total_balance: "សមតុល្យសរុប",
  total_tran: "ប្រតិបត្តិការសរុប",
  total_base: "ភ្នាល់សមាជិកសរុប",
  tennis_min_bet: "@:ui.tennis @:ui.min_bet",
  tennis_max_bet: "@:ui.tennis @:ui.max_bet",
  tennis_max_per_match: "@:ui.tennis @:ui.max_per_match",
  top_winner: "អ្នកឈ្នះ ១០ លេខកំពូលក្នុងខែ",
  top_turnover: "អ្នកមានបង្វិលប្រាក់ខ្ពស់ជាងគេ ១០ លេខកំពូលក្នុងខែ",
  top_loser: "អ្នកចាញ់ច្រើនបំផុត ១០ លេខកំពូលក្នុងខែ",
  type: "ប្រភេទ",
  total_downline: "សរុបអ្នកក្រោម",
  to: "ទៅ",
  transfer: "ផ្ទេរ",
  transfer_list: "បញ្ជីផ្ទេរ",
  transfer_history: "ប្រវត្តិផ្ទេរ",
  this_month: "ខែនេះ",
  this_week: "សប្ដាហ៍នេះ",
  total_accepted: "បានអនុម័តសរុប",
  total_rejected: "បានបដិសេធសរុប",
  total_stake: "ភ្នាល់សរុប",
  total_winlose: "ឈ្នះ/ចាញ់សរុប",
  total_member: "សមាជិកសរុប",
  tournament: "ការប្រកួត",
  tournament_jackpot: "រង្វាន់ធំការប្រកួត",
  tournament_refund_list: "បញ្ជីសងប្រាក់វិញការប្រកួត",

  under: "ក្រោម",
  upline_id: "លេខសម្គាល់អ្នកលើ",
  unblock: "ដោះសោ",
  update: "អាប់ដេត",
  username: "ឈ្មោះអ្នកប្រើ",
  update_commission_sb: "កម្រៃជើងសារ Sportsbook",
  update_commission_lc: "កម្រៃជើងសារ Livecasino",
  update_commission_sl: "កម្រៃជើងសារ Slots",
  update_commission_lo: "កម្រៃជើងសារ Lotto",
  update_commission_kn: "កម្រៃជើងសារ Keno",
  update_commission_cf: "កម្រៃជើងសារ ESports2",
  update_commission_lt: "កម្រៃជើងសារ Lottery",
  update_bet_limit_lc: "ដែនកំណត់ភ្នាល់ Livecasino",
  update_bet_limit_sb: "ដែនកំណត់ភ្នាល់ Sportsbook",
  update_bet_limit_lo: "ដែនកំណត់ភ្នាល់ Lotto",
  update_bet_limit_kn: "ដែនកំណត់ភ្នាល់ Keno",
  update_bet_limit_cf: "ដែនកំណត់ភ្នាល់ ESports2",
  update_bet_limit_lt: "ដែនកំណត់ភ្នាល់ Lottery",
  update_position_sb: "កំណត់ទីតាំង Sportsbook",
  update_position_lc: "កំណត់ទីតាំង Livecasino",
  update_position_sl: "កំណត់ទីតាំង Slots",
  update_position_lo: "កំណត់ទីតាំង Lotto",
  update_position_kn: "កំណត់ទីតាំង Keno",
  update_position_cf: "កំណត់ទីតាំង ESports2",
  update_position_lt: "កំណត់ទីតាំង Lottery",
  update_account: "អាប់ដេតគណនី",
  update_platform: "អាប់ដេតវេទិកា",
  upline_pt: "ការទទួល PT ដោយអ្នកលើ",
  upline_remaining: "PT នៅសល់របស់អ្នកលើ",
  unblock_profile: "ដោះសោប្រវត្តិរូប",
  unselect_all: "ដោះជ្រើសរើសទាំងអស់",

  view_details: "មើលលម្អិត",
  view_downline: "មើលអ្នកក្រោម",
  value: "តម្លៃ",
  valid_turnover: "ការបង្វិលត្រឹមត្រូវ",
  void: "បោះបង់",

  winlose_limit: "ដែនកំណត់ឈ្នះ/ចាញ់",
  wallet: "កាបូប",
  winlose: "ឈ្នះ/ចាញ់",
  win_limit: "ដែនកំណត់ឈ្នះ",
  win_limit_multiplier: "តម្លៃគុណដែនកំណត់ឈ្នះ",
  win_limit_tooltips: "អនុវត្តបានសម្រាប់តែ Livecasino និង Slots ប៉ុណ្ណោះ។",
  win_limit_tooltips1: "ដោយសារតែ API នៃស្លុតនិងកាស៊ីណូមានការពន្យារ អ្នកលេងអាចបន្តភ្នាល់បានបន្តិចបន្ទាប់ពីឈានដល់ដែនកំណត់ឈ្នះ។",
  win_limit_0: "គ្មានដែនកំណត់",
  win_limit_1: "ដែនកំណត់ឥណទាន x 1",
  win_limit_2: "ដែនកំណត់ឥណទាន x 2",
  win_limit_5: "ដែនកំណត់ឥណទាន x 5",
  win_limit_10: "ដែនកំណត់ឥណទាន x 10",
  win_limit_20: "ដែនកំណត់ឥណទាន x 20",
  winlose_column1: "ឈ្នះ/ចាញ់",
  winlose_column2: "កម្រៃជើងសារ",
  winlose_today: "ឈ្នះ/ចាញ់ថ្ងៃនេះ",
  winlose_yesterday: "ឈ្នះ/ចាញ់ម្សិលមិញ",
  winner: "អ្នកឈ្នះ",
  won: "ឈ្នះ",
  win_half: "ឈ្នះពាក់កណ្តាល",
  withdrawal: "ដកប្រាក់",
  
  yesterday: "ម្សិលមិញ",
  yesterday_balance: "សមតុល្យម្សិលមិញ",

  provider_evo: "Evolution",
  provider_gp: "Game Play",
  provider_vivo: "Vivo suite",
  provider_sa: "SA Gaming",
  provider_ct: "CT855",
  provider_ptg: "Pretty Gaming",
  provider_yb: "Yeebet",
  "provider_pp-c": "Pragmatic",
  provider_lotto: "Lotto",
  provider_keno: "Keno",
  provider_cockfight: "ESports2",
  provider_lottery: "Lottery",
  provider_ar: "Arcadia Gaming",
  provider_slots: "ស្លុត (Live22)",
  provider_pgs: "ស្លុត (PGSoft)",
  provider_pp: "ស្លុត (PP)",
  provider_jk: "ស្លុត (Joker)",
  provider_sp: "ស្លុត (SimplePlay)",
  provider_jili: "ស្លុត (Jili)",
  provider_uu: "ស្លុត (UU)",
  provider_db: "ស្លុត (DBHash)",
  provider_next: "ស្លុត (Next)",
  provider_dbp: "Poker (DBHash)",
  provider_epw: "Poker (Epicwin)",
  provider_sexybcrt: "Sexy Baccarat",
  provider_bi: "Binary",
  provider_onlive: "Onlive Casino",
  provider_mtlive: "MT Casino",

  timer: "ពេលវេលា",
  no_refresh: "មិនបញ្ចេញទិន្នន័យឡើងវិញ",
  actual_yesterday_balance: "សមតុល្យពិតប្រាកដម្សិលមិញ",

  loading: "កំពុងផ្ទុក...",
  slide_puzzle: "រមូររូបភាព",
  drag_to_verify: "អូសដើម្បីផ្ទៀងផ្ទាត់",
  running_score: "ពិន្ទុនៅពេលកំពុងលេង",
  unblock_account: "ដោះសោគណនី",
  password_expired: "លេខសម្ងាត់ផុតកំណត់",

  lotto_upline_pt : "@:ui.lotto @:ui.upline_pt",
  lotto_account_pt : "@:ui.lotto @:ui.account_pt",
  lotto_upline_remaining : "@:ui.lotto @:ui.upline_remaining",
  lotto_account_min : "@:ui.lotto @:ui.account_min",
  keno_upline_pt : "@:ui.keno @:ui.upline_pt",
  keno_account_pt : "@:ui.keno @:ui.account_pt",
  keno_upline_remaining : "@:ui.keno @:ui.upline_remaining",
  keno_account_min : "@:ui.keno @:ui.account_min",
  cockfight_upline_pt : "@:ui.cockfight @:ui.upline_pt",
  cockfight_account_pt : "@:ui.cockfight @:ui.account_pt",
  cockfight_upline_remaining : "@:ui.cockfight @:ui.upline_remaining",
  cockfight_account_min : "@:ui.cockfight @:ui.account_min",
  lottery_upline_pt : "@:ui.lottery @:ui.upline_pt",
  lottery_account_pt : "@:ui.lottery @:ui.account_pt",
  lottery_upline_remaining : "@:ui.lottery @:ui.upline_remaining",
  lottery_account_min : "@:ui.lottery @:ui.account_min",
  livecasino_tooltips: "ការប្រកួតសារតាមកំណត់របស់បាល់ទាត់។",
  notice: "សេចក្តីជូនដំណឹង",

  // OTP 2FA Translations
  setup_otp_via_mobile_authenticator: "កំណត់ OTP តាមរយៈកម្មវិធីផ្ទៀងផ្ទាត់អត្តសញ្ញាណចល័ត",
  step_1_download_google_authenticator: "1. ទាញយក Google Authenticator នៅលើឧបករណ៍របស់អ្នក។",
  step_2_create_account_scan_qr: "2. បង្កើតគណនីដោយស្កេន QR code នេះជាមួយ Google Authenticator។",
  step_3_enter_6_digit_code_verify: "3. បញ្ចូលលេខកូដ 6 ខ្ទង់ដែលបង្កើតដោយ Google Authenticator ទៅក្នុងប្រអប់អត្ថបទខាងក្រោម ហើយបន្ទាប់មកចុចផ្ទៀងផ្ទាត់ដើម្បីបញ្ចប់ការចុះឈ្មោះ។",
  download_on_app_store: "ទាញយកនៅលើ App Store",
  get_it_on_google_play: "ទាញយកនៅលើ Google Play",
  regenerate_qr: "បង្កើត QR Code ឡើងវិញ",
  unable_to_scan_qr_code: "មិនអាចស្កេន QR code?",
  manual_entry_secret: "លេខសម្ងាត់បញ្ចូលដោយដៃ",
  otp: "OTP",
  verify: "ផ្ទៀងផ្ទាត់",
  enable_otp_via_mobile_authenticator_app: "បើកដំណើរការ OTP តាមរយៈកម្មវិធីផ្ទៀងផ្ទាត់អត្តសញ្ញាណចល័ត",
  two_factor_authenticator_bound: "ការផ្ទៀងផ្ទាត់អត្តសញ្ញាណពីរកត្តាត្រូវបានភ្ជាប់",
  unbind: "ដោះភ្ជាប់",
  setup_2fa: "កំណត់ 2FA",
  enter_6_digit_code: "បញ្ចូលលេខកូដ 6 ខ្ទង់",
  verification_code: "លេខកូដផ្ទៀងផ្ទាត់",

  // Telegram OTP Translations
  setup_otp_via_telegram_chatbot: "កំណត់ OTP តាមរយៈ Telegram Chatbot",
  step_1_download_telegram: "1. ទាញយកកម្មវិធីនៅលើ Google Play/App Store។",
  step_2_signup_and_generate_qr: "2. បង្កើតគណនីដោយស្កេន QR code នេះជាមួយ Telegram។",
  step_3_enable_telegram_bot: "3. បើក Telegram Bot។",
  show_qr_code: "បង្កើត QR Code",
  hide_qr_code: "លល់ QR Code",
  generate_qr_code: "បង្កើត QR Code",
  enable_otp_via_telegram_chatbot: "បើក OTP តាមរយៈ Telegram Chatbot",
  telegram_bot_bound: "Telegram Bot បានភ្ជាប់",
  otp_telegram: "OTP Telegram",
  get_otp: "ស្វែងយល់ OTP",
  cashout: "ដកប្រាក់",
  time_machine: "ពេលវេលា",
};